
import React from 'react'
import {Link} from 'react-router-dom'

const Navbar = () => {
  return (
       <nav className='wrapper'>
      <div className='container'>
        <Link className='links' to='/FactOne' >Fact One</Link>
        <Link className='links' to='/FactTwo' >Fact Two</Link>
        <Link className='links' to='/FactThree' >Fact Three</Link>
      </div>
    </nav>
  )
}

export default Navbar


